export enum WizardStepId {
  NAME = 'name',
  ADDRESS = 'address',
  EMAIL = 'email',
  SCHOOL = 'school',
  GESCHWISTER = 'geschwister',
  PAYMENT = 'payment',
  SUMMARY = 'summary',
}

export interface WizardStep {
  id: WizardStepId;
  titleKey: string;
}

export const WIZARD_STEPS: WizardStep[] = [
  {id: WizardStepId.NAME, titleKey: 'TICKETS.VERIFICATION_WIZARD.STEPS.NAME'},
  {id: WizardStepId.ADDRESS, titleKey: 'TICKETS.VERIFICATION_WIZARD.STEPS.ADDRESS'},
  {id: WizardStepId.EMAIL, titleKey: 'TICKETS.VERIFICATION_WIZARD.STEPS.EMAIL'},
  {id: WizardStepId.SCHOOL, titleKey: 'TICKETS.VERIFICATION_WIZARD.STEPS.SCHOOL'},
  {id: WizardStepId.GESCHWISTER, titleKey: 'TICKETS.VERIFICATION_WIZARD.STEPS.GESCHWISTER'},
  {id: WizardStepId.PAYMENT, titleKey: 'TICKETS.VERIFICATION_WIZARD.STEPS.PAYMENT'},
  {id: WizardStepId.SUMMARY, titleKey: 'TICKETS.VERIFICATION_WIZARD.STEPS.SUMMARY'},
];
